/* ===================================================================
   Session context object + types (Hopper, 2026-06-09).

   Split out from SessionProvider.tsx so that file only exports a
   component (keeps react-refresh happy). useSession.ts and the provider
   both import from here.
   =================================================================== */

import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export interface SessionContextValue {
  session: Session | null;
  user: User | null;
  loading: boolean;
  /** True when the Supabase env (url + anon key) is present. */
  configured: boolean;
  /**
   * True when the current session arrived via a PASSWORD RECOVERY link
   * (Supabase PASSWORD_RECOVERY event and/or a `type=recovery` URL hash).
   * While true the app must NOT route the user into the dashboard: it must
   * force the "set a new password" screen first. Cleared once the password
   * is successfully set (or on sign-out). Load-bearing security state --
   * a recovery session has no durable password set yet.
   */
  passwordRecovery: boolean;
  /** Clears the recovery flag after a successful password set. */
  clearPasswordRecovery: () => void;
  signOut: () => Promise<void>;
}

export const SessionContext = createContext<SessionContextValue | undefined>(
  undefined,
);
